<prism-ui-page-content
  key-id="page-content"
  custom-max-width="680"
  >
  @if (companyId === "SI" || companyId === "NM") {
    <div id="header">
      <prism-ui-heading
        key-id="heading-default"
        level="1"
        font-size="lg"
        font-weight="regular"
        is-uppercase="false"
        variant="default"
        >
        <span
        [innerHTML]="
          esignDiscContent.title
        "
        ></span>
      </prism-ui-heading>
    </div>
    <form id="consentForm" [formGroup]="consentForm" (ngSubmit)="onSubmit()" autocomplete="off">
      <prism-ui-container
        class="paddingTB20x"
        is-compact="false"
        key-id="esign-container"
        has-shadow="false"
        variant="default"
        has-no-border-radius="false"
        >
        <div class="row" id="printable">
          <prism-ui-copy
            key-id="esign-disc-content"
            fontSize="md"
            variant="default"
            line-height="loose"
          [innerHTML]="
            eSignDiscContentData['body']
          "
            >
          </prism-ui-copy>
          <br> <br>
          <prism-ui-copy
            key-id="esign-disc-content-state"
            fontSize="md"
            variant="default"
          [innerHTML]="
            eSignDiscContentData['addressLine']
          "
            >
          </prism-ui-copy>
          <br> <br>
          <prism-ui-copy
            key-id="esign-disc-content-state"
            fontSize="md"
            variant="default"
          [innerHTML]="
            eSignDiscContentData['eSignFormNumber']
          "
            >
          </prism-ui-copy>
          <br>
            <prism-ui-copy
              key-id="esign-disc-content-state"
              fontSize="md"
              variant="default"
          [innerHTML]="
           eSignDiscContentData['eSignFormState']
          "
              >
            </prism-ui-copy>
            <br> <br>

            <prism-ui-form-field
              key-id="emailName"
              [isValid]="formControlUtilitiesService.isControlValid(consentForm, 'email')"
              >
              <span slot="label">{{ emailElement?.label }}</span>
              @if (email.pending) {
                <span span slot="error">Validating...</span>
              }
              @else if (!email.pending && email.status === 'INVALID' && email.touched){
              <span slot="error">
                @if (email.touched &&  email.hasError('required')) {
                  <span>{{ emailElement?.error }}</span>
                }
                @if (email.touched && email.hasError('pattern')) {
                  <span>{{ emailElement?.error }}</span>
                }
                @if (email.touched && email.hasError('invalidEmail')) {
                <span>{{ emailElement?.error }}</span>
                }
              </span>
            }
            </prism-ui-form-field>

            <prism-ui-input-email
              autocomplete="off"
              autofill="off"
              slot="input"
              is-required="true"
              is-small="false"
              ngDefaultControl
              formControlName="email"
              [formGroup]="consentForm"
              [name]="emailName"
              key-id="emailName"
              placeholder="{{emailElement?.placeholder}}"
              [isValid]="formControlUtilitiesService.isControlValid(consentForm, 'email')"
            ></prism-ui-input-email>

            <prism-ui-form-field-select
              key-id="checkboxesKey"
              form-field-items-count="1"
          [isValid]="
            formControlUtilitiesService.setCheckboxFormValid(consentForm)
          "
              >
              <span slot="error">{{ consentElement?.error }}</span>

            </prism-ui-form-field-select>

            <prism-ui-checkbox
              formControlName="consent"
              [formGroup]="consentForm"
              key-id="consent"
          [labelText]="
            eSignDiscContentData['acknowledgementText']
          "
              ngDefaultControl
          (prismUiCheckboxOnChange)="
            formControlUtilitiesService.toggleIndividualCheckbox(
              $event,
              'consent',
              consentForm
            )
          "
          [isValid]="
            formControlUtilitiesService.setCheckboxFormValid(consentForm)
          "
            ></prism-ui-checkbox>
          </div>
        </prism-ui-container>
        <!-- "I Agree and Cancel buttons" -->
        <div class="center paddingTB12x">
          <div class="center btn">
            <div class="row">
              <app-continue-cancel
                (cancelEmitter)="onCancel()"
                [primaryName]="agreeButton"
              ></app-continue-cancel>
            </div>
          </div>
        </div>
      </form>
    }
    @else {
    <div id="header">
      <prism-ui-heading
        key-id="heading-default"
        level="1"
        font-size="lg"
        font-weight="regular"
        is-uppercase="false"
        variant="default"
        >
        <span
        [innerHTML]="
          esignDiscContent.body
            .split('</p>')[0]
            .replace('<strong>', '')
            .replace('</strong>', '')
        "
    ></span>
  </prism-ui-heading>
</div>
<form id="consentForm" [formGroup]="consentForm" (ngSubmit)="onSubmit()" autocomplete="off">
  <prism-ui-container
    class="paddingTB20x"
    is-compact="false"
    key-id="esign-container"
    has-shadow="false"
    variant="default"
    has-no-border-radius="false"
    >
    <!-- Print Button -->
    <div class="row">
      <div class="button-print">
        <prism-ui-button
          class="center"
          button-width="content"
          icon-name="print"
          key-id="print-button"
          size="md"
          variant="text"
          type="button"
          is-icon-right-aligned="false"
          is-waiting="false"
          (click)="onPrint()"
          >Print</prism-ui-button
          >
        </div>
      </div>
      <div class="row" id="printable">
        <prism-ui-copy
          key-id="esign-disc-content"
          fontSize="md"
          variant="default"
          line-height="loose"
          [innerHTML]="
            esignDiscContent.body.split('</p>')[3].replace('<hr />', '')
          "
        >
      </prism-ui-copy>
      <prism-ui-copy
        key-id="esign-disc-content-state"
        fontSize="md"
        variant="default"
          [innerHTML]="
            esignDiscContent.body
              .replace('\n', '')
              .split('</p>')[4]
              .replace('<p>', '')
              .replace('</p>', '') +
            
            esignDiscContent.body
              .split('</p>')[5]
              .replace('<p>', '')
              .replace('</p>', '')
          "
>
</prism-ui-copy>

<prism-ui-form-field-select
  key-id="checkboxesKey"
  form-field-items-count="1"
          [isValid]="
            formControlUtilitiesService.setCheckboxFormValid(consentForm)
          "
  >
  <span slot="error">{{ consentElement?.error }}</span>
</prism-ui-form-field-select>

<prism-ui-checkbox
  formControlName="consent"
  [formGroup]="consentForm"
  key-id="consent"
          [labelText]="
            esignDiscContent.body
              .split('</p>')[1]
              .replace('<p>', '')
              .replace('</p>', '')
          "
ngDefaultControl
          (prismUiCheckboxOnChange)="
            formControlUtilitiesService.toggleIndividualCheckbox(
              $event,
              'consent',
              consentForm
            )
          "
          [isValid]="
            formControlUtilitiesService.setCheckboxFormValid(consentForm)
          "
></prism-ui-checkbox>
</div>
</prism-ui-container>
<!-- "I Agree and Cancel buttons" -->
<div class="center paddingTB12x">
  <div class="center btn">
    <div class="row">
      <app-continue-cancel
        (cancelEmitter)="onCancel()"
        [primaryName]="agreeButton"
      ></app-continue-cancel>
    </div>
  </div>
</div>
</form>
}

</prism-ui-page-content>


<prism-ui-modal key-id="cancel-modal" has-dark-overlay="true">
  <prism-ui-heading
    slot="modal-header"
    key-id="cancel-modal"
    font-size="sm"
    font-weight="strong"
    >{{ modalContentHeading }}</prism-ui-heading
    >
    <prism-ui-copy slot="modal-body" key-id="cancel-modal">
      {{ modalContentBody }}
    </prism-ui-copy>
    <div slot="modal-footer" style="display: flex; justify-content: center">
      <prism-ui-button-group
        key-id="modal-continue-cancel-button-group"
        buttons-count="2"
        spacing="default"
        >
        <prism-ui-button
          slot="1"
          button-width="full"
          key-id="cancel-button"
          size="md"
          variant="secondary"
          type="button"
          is-icon-right-aligned="false"
          (click)="onCancelModal('prism-ui-modal-cancel-modal')"
          >Cancel</prism-ui-button
          >
          <prism-ui-button
            slot="2"
            button-width="full"
            key-id="continue-button"
            size="md"
            variant="primary"
            type="button"
            is-icon-right-aligned="false"
            (click)="leaveAnyway()"
            >Leave Anyway</prism-ui-button
            >
          </prism-ui-button-group>
        </div>
      </prism-ui-modal>
